module.exports = __webpack_public_path__ + "img/isic.39bf4072.png";